import axios from "axios";
import { localGet } from "./common-method";
import CryptoJS from "crypto-js";
import store from "@/store";
import Vue from "vue";

const BASE_URL = process.env.VUE_APP_BASE_API;
const request = axios.create({
  baseURL: BASE_URL, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
});
request.interceptors.request.use(
  (config) => {
    config.headers["X-TOKEN"] = localGet("TOKEN");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    const isLogin = response.config.headers["X-TO"];
    const method = response.config.method;
    // if (response.data.code === 401 || response.data === "暂未登录") {
    //   localRemove("TOKEN");
    //   localRemove("USERINFO");
    // }
    if (
      response.data &&
      response.data.code === 401 &&
      (method.toUpperCase() === "POST" ||
        method.toUpperCase() === "PUT" ||
        method.toUpperCase() === "DELETE" ||
        isLogin)
    ) {
      Vue.prototype
        .$login({ TYPE: "LOGIN" })
        .then((token) => {
          store.dispatch("set_token", token);
          window.location.reload();
        })
        .catch((reason) => {
          if (reason !== "cancel") console.log("登录取消");
        });
    } else if (isLogin && response.data === "暂未登录") {
      Vue.prototype
        .$login({ TYPE: "LOGIN" })
        .then((token) => {
          store.dispatch("set_token", token);
          window.location.reload();
        })
        .catch((reason) => {
          if (reason !== "cancel") console.log("登录取消");
        });
    } else {
      if (response.data.code !== 401) {
        if (response.data.encryption) {
          const keyStr = "0$0H_3p4$567890F0Kd0?123456789$@";
          const defIvHex = CryptoJS.enc.Utf8.parse("0012345900000678");
          const defKey = CryptoJS.enc.Utf8.parse(keyStr);
          const decrypted = CryptoJS.AES.decrypt(response.data.result, defKey, {
            iv: defIvHex,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }).toString(CryptoJS.enc.Utf8);
          response.data.result = JSON.parse(decrypted);
        }
        return response.data;
      }
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default request;
